import axios from "axios";
import { useCallback, useEffect } from "react";
import { useState } from "react";

const useCart = (user, userInfo) => {
  useEffect(() => {}, []);
  const [cartItems, setCartItems] = useState([]);
  const [reachedMax, setReachedMax] = useState(0);

  const [coupons, setCoupons] = useState([
    {
      code: "AMBHOS100",
      discount: 100,
      minPrice: 999,
    },
    {
      code: "AMBHOS150",
      discount: 150,
      minPrice: 1499,
    },
    {
      code: "AMBHOS200",
      discount: 200,
      minPrice: 1999,
    },
  ]);

  const handleCartUpdate = useCallback(
    (id, selectedSize, inventory) => {
      // console.log(cartItems);
      const existingProduct = cartItems?.find(
        (item) => item.productId === id && item.selectedSize === selectedSize
      );

      let updatedCartItems = [];

      if (existingProduct) {
        // Update the quantity of the existing product
        updatedCartItems = cartItems?.map((item) => {
          if (item.productId === id && item.selectedSize === selectedSize) {
            if (item.quantity < inventory) {
              setReachedMax(200);
              return {
                ...item,
                quantity: item.quantity + 1,
              };
            } else {
              setReachedMax(500);
            }
          }
          return item;
        });
      } else {
        updatedCartItems = [
          ...cartItems,
          {
            productId: id,
            selectedSize: selectedSize,
            quantity: 1,
          },
        ];
        setReachedMax(200);
      }
      // console.log("updatedCartItems", updatedCartItems);
      if (updatedCartItems.length > 0) {
        if (user) {
          axios
            .post(`${process.env.REACT_APP_BACKEND_LINK}/updatecart`, {
              userInfo,
              updatedCartItems,
            })
            .then((res) => console.log(res))
            .catch((err) => console.log(err));
        } else {
          localStorage.setItem(
            "ambhosCartItems",
            JSON.stringify(updatedCartItems)
          );
        }
        setCartItems(updatedCartItems);
      }
      // console.log("Added to cart", cartItems);
    },
    [cartItems]
  );

  return {
    handleCartUpdate,
    cartItems,
    setCartItems,
    coupons,
    reachedMax,
    setReachedMax,
  };
};

export default useCart;
